import React, { useState } from 'react';


import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import {
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from '@material-ui/core';

import {
    Visibility,
    VisibilityOff
} from '@material-ui/icons';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import AccountService from '../../services/account.service';

import '../../styles/style.scss';

export const AccountScreen = () => {

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();

    const [isChangingPassword, setIsChangingPassword] = useState(false);

    const [values, setValues] = React.useState({
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        showOldPassword: false,
        showNewPassword: false,
        showconfirmNewPassword: false,
    });
    //Cambio de regex largo a uno mas corto, previene ataques de denegacion de servicio
    // const regex = /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?!.*[ áéíóúäëïöüñ¨´`'])(?=.{8,}).*$/;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[^\sáéíóúäëïöüñ¨´`']{8,}$/;

    const validationSchema = Yup.object().shape({
        oldPassword: Yup.string().required('Contraseña es requerida.'),
        newPassword: Yup.string().required('Contraseña es requerida.')
        .matches(regex,
            'La contraseña debe contener mayusculas, minusculas, numeros y un caracter. Debe tener al menos 8 caracteres y no contener espacios o acentos.')
        .notOneOf([Yup.ref('oldPassword')], "La nueva contraseña no debe ser igual a la anterior."),
        confirmNewPassword: Yup.string().required('Contraseña es requerida.')
        .oneOf([Yup.ref('newPassword'), null], "Las contraseñas no coinciden."),
    });
    
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    /**
     * Cambiar valor en formulario de acuerdo al campo de contraseña ingresado
     * @param { string } typePassword - variable que define el tipo de contraseña de acuerdo al imput usado
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleClickShowPassword = (typePassword) => {
        if(typePassword==='old'){
            setValues({ ...values, showOldPassword: !values.showOldPassword });
        }
        if(typePassword==='new'){
            setValues({ ...values, showNewPassword: !values.showNewPassword });
        }
        if(typePassword==='confirm'){
            setValues({ ...values, showconfirmNewPassword: !values.confirmNewPassword });
        }
    };
    
    /**
     * Recupera acción al ingresar valores en los input del formulario
     * @param {*} event - datos de entrada
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    /**
     * Ejecutar el servicio de cambio de contraseña
     * @param {*} data - informacion del formulario
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const onSubmit = (data) => {
        setIsChangingPassword(true);
        AccountService.getChangePassword(data).then(()=>{
            setIsChangingPassword(false);
            Swal.fire({
                icon: 'success',
                title: 'Contraseña cambiada.',
                showConfirmButton: false,
                timer: 1500
              });
              window.location.reload()
        })
        .catch((error)=>{
            setIsChangingPassword(false);
            if(error?.response?.status === 401){
                if(sessionDifference > Number(tokenExpired)){
                    sesionExpired(dispatch, history);
                }else{
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Contraseña actual invalida.',
                      showConfirmButton: true,
                      confirmButtonText: 'Aceptar'
                    });
                  }
            }else{
                actionErrorConnection(error, 'Error al cambiar contraseña');
            }
        });
    };

    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                        <SidebarMenu/>
                    </div>
                    <div className="col p-0 ms-1 me-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <span>Cuenta </span>
                                </div>
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <form>
                                        <div className="container p-0">
                                            <div className="row ">
                                                <div className="col-md-3">
                                                    <div className="border-text-menu-title">
                                                        <span className="text-subtitle" >Cambio de contraseña</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-9 pt-5 pb-2">
                                                    <div className="row">
                                                        <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                            <TextField
                                                                required
                                                                className="w-100"
                                                                id="oldPassword"
                                                                name="oldPassword"
                                                                label="Contraseña actual"
                                                                type={values.showOldPassword ? "text" : "password"}
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={isChangingPassword}
                                                                {...register('oldPassword')}
                                                                error={!!errors.oldPassword}
                                                                InputProps={{
                                                                    endAdornment:
                                                                        <InputAdornment position="end">
                                                                        <IconButton
                                                                        edge="end"
                                                                            onClick={()=>handleClickShowPassword('old')}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                        >
                                                                            {values.showOldPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                        </InputAdornment>
                                                                }}
                                                                
                                                            />
                                                            <Typography variant="inherit" color="error">
                                                                {errors.oldPassword?.message}
                                                            </Typography>
                                                        </div>
                                                    </div> 
                                                    <div className="row">
                                                        <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                            <TextField
                                                                required
                                                                className="w-100"
                                                                id="newPassword"
                                                                name="newPassword"
                                                                label="Nueva contraseña"
                                                                type={values.showNewPassword ? "text" : "password"}
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={isChangingPassword}
                                                                {...register('newPassword')}
                                                                error={!!errors.newPassword}
                                                                InputProps={{
                                                                    endAdornment:
                                                                        <InputAdornment position="end">
                                                                        <IconButton
                                                                        edge="end"
                                                                            onClick={()=>handleClickShowPassword('new')}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                        >
                                                                            {values.showNewPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                        </InputAdornment>
                                                                }}
                                                            />
                                                            <Typography variant="inherit" color="error">
                                                                {errors.newPassword?.message}
                                                            </Typography>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                            <TextField
                                                                required
                                                                className="w-100"
                                                                id="confirmNewPassword"
                                                                name="confirmNewPassword"
                                                                label="Repetir contraseña"
                                                                type={values.showconfirmNewPassword ? "text" : "password"}
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={isChangingPassword}
                                                                {...register('confirmNewPassword')}
                                                                error={!!errors.confirmNewPassword}
                                                                InputProps={{
                                                                    endAdornment:
                                                                        <InputAdornment position="end">
                                                                        <IconButton
                                                                        edge="end"
                                                                            onClick={()=>handleClickShowPassword('confirm')}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                        >
                                                                            {values.showconfirmNewPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                        </InputAdornment>
                                                                }}
                                                            />
                                                            <Typography variant="inherit" color="error">
                                                                {errors.confirmNewPassword?.message}
                                                            </Typography>
                                                        </div>
                                                        <div className="col-md-12 col-lg-4 d-flex justify-content-end">
                                                            <div>
                                                                <button  
                                                                    className="btn custom-btn pt-2 pb-2 ps-3 pe-3 mt-1 mb-1" 
                                                                    onClick={handleSubmit(onSubmit)}
                                                                    disabled={isChangingPassword}
                                                                >
                                                                    <span className="me-2">Guardar</span>
                                                                    {
                                                                        isChangingPassword 
                                                                        ? <i className="fas fa-spinner fa-spin"></i>
                                                                        : <i className="fas fa-save"></i>
                                                                    } 
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}